import React, { PureComponent } from 'react';

import { createCustomField } from '../actions/custom-fields';

import { getCurrentTeam } from '../services/store-service';
import { CUSTOM_FIELDS } from '../constants/custom-fields';

import Select from './select';
import FieldDefault from './field-default';
import CustomFieldDropdownOptions from './custom-field-dropdown-options';
import CustomFieldSelector from './custom-field-selector';
import Checkbox from './checkbox';
import CustomFieldsLibrary from './custom-fields-library';
import BudgetField from './budget-field';

const CURRENCY_OPTIONS = [
    {
        id: 'usd',
        text: 'US Dollar ($)'
    },
    {
        id: 'eur',
        text: 'Euro (¢)'
    },
    {
        id: 'gbp',
        text: 'GB Pound (£)'
    }
];

export default class CustomFieldEditor extends PureComponent {
    static defaultProps = {
        type: 'text',
        name: '',
        currency: 'usd'
    };

    state = {
        selectFromLibrary: false,
        loading: false,
        type: this.props.type,
        name: this.props.name,
        hideFromGuests: this.props.hideFromGuests,
        currency: this.props.currency,
        options: this.props.options,
        costPerHour: this.props.costPerHour,
        trackingType: this.props.trackingType,
        save: this.props.save
    };

    handleCreateNewClick = () => {
        this.setState({
            selectFromLibrary: false
        });
    }

    handleSelectFromLibraryClick = () => {
        this.setState({
            selectFromLibrary: true
        });
    }

    handleFieldSelect = type => {
        this.setState({ type });
    }

    handleNameChange = name => {
        this.setState({ name });
    }

    handleAddToLibraryChange = save => {
        this.setState({ save });
    }

    handleHideFromGuestsChange = hideFromGuests => {
        this.setState({ hideFromGuests });
    }

    handleCurrencySelect = ({ id: currency }) => {
        this.setState({ currency });
    }

    handleOptionsChange = options => {
        this.setState({ options });
    }

    handleCostPerHourChange = costPerHour => {
        this.setState({ costPerHour });
    }

    handleTrackingTypeChange = trackingType => {
        this.setState({ trackingType });
    }

    handleSave = () => {
        this.save();
    }

    handleSelectFromLibrary = id => {
        this.save(id);
    }


    save(fieldId) {
        this.setState({
            selectFromLibrary: false,
            loading: true
        });

        this.requstSave(fieldId)
            .then(() => {
                this.setState({
                    loading: false
                });

                this.props.onComplete && this.props.onComplete();
            })
            .catch(() => {
                this.setState({
                    loading: false
                });
            });
    }

    requstSave(fieldId) {
        if (fieldId) {
            return createCustomField({
                fieldId,
                associations: [this.props.association],
                associationId: this.props.associationId,
                projectId: this.props.projectId
            });
        }
        // if (this.props.id) {
        //     return updateCustomField(this.props.id, {
        //         name: this.state.name,
        //         description: this.state.description,
        //         roles: this.state.roles,
        //         currency: this.state.type === 'currency' ? this.state.currency : undefined,
        //         options: this.state.type === 'dropdown' ? this.state.options : undefined
        //     });
        // }

        return createCustomField({
            type: this.state.type,
            name: this.state.name,
            associations: [this.props.association],
            associationId: this.props.associationId,
            description: this.state.description,
            hidden: this.state.hideFromGuests ? ['client'] : [],
            currency: this.state.type === 'currency' ? this.state.currency : undefined,
            options: this.state.type === 'dropdown' ? this.state.options : undefined,
            cost_per_hour: this.state.type === 'budget' ? this.state.costPerHour : undefined,
            tracking_type: this.state.type === 'budget' ? this.state.trackingType : undefined,
            projects: [this.props.projectId],
            in_library: this.state.save
        });
    }

    get fieldMain() {
        switch (this.state.type) {
            case 'currency':
                return (
                    <div className="form-row">
                        <Select
                            label="Currency"
                            darkLabel={true}
                            options={CURRENCY_OPTIONS}
                            selected={this.state.currency}
                            onSelect={this.handleCurrencySelect}
                        />
                    </div>
                );

            case 'dropdown':
                return <CustomFieldDropdownOptions options={this.props.options} onChange={this.handleOptionsChange} />;

            case 'budget':
                return (
                    <div className="form-row">
                        <BudgetField
                            autoTracking={this.props.association === 'task'}
                            trackedTime={this.props.trackedTime}
                            costPerHour={this.props.costPerHour}
                            trackingType={this.props.trackingType}
                            onCostPerHourChange={this.handleCostPerHourChange}
                            onTrackingTypeChange={this.handleTrackingTypeChange}
                        />
                    </div>
                );

            default:
                return null;

        }

        return null;
    }

    get populated() {
        if (this.state.type === 'dropdown') {
            return !!this.state.name && this.state.options && this.state.options.filter(option => option.value).length;
        }

        return !!this.state.name;
    }

    render() {
        return (
            <div className="custom-field-editor">
                <div className="custom-field-editor-nav horizontal-nav">
                    <div className={'horizontal-nav-item' + (!this.state.selectFromLibrary ? ' active' : '')} data-text="Create new" onClick={this.handleCreateNewClick}>
                        Create new
                    </div>

                    <div className={'horizontal-nav-item' + (this.state.selectFromLibrary ? ' active' : '')} data-text="Choose from library" onClick={this.handleSelectFromLibraryClick}>
                        Choose from library
                    </div>
                </div>

                <div className="custom-field-editor-body">
                    {
                        !this.state.selectFromLibrary ? (
                            <div className="custom-field-editor-pane">
                                <div className="form">
                                    <div className="form-row">
                                        <div className="field-label dark">
                                            Field Type
                                        </div>

                                        <CustomFieldSelector options={CUSTOM_FIELDS} selected={this.state.type} onSelect={this.handleFieldSelect} />
                                    </div>

                                    <div className="form-row">
                                        <FieldDefault label="Field Name" placeholder="Give it a name…" darkLabel={true} value={this.state.name} onChange={this.handleNameChange} />
                                    </div>

                                    { this.fieldMain }

                                    <div className="form-row">
                                        <p className="checkbox-holder">
                                            <Checkbox checked={this.state.addToLibrary} onChange={this.handleAddToLibraryChange} />

                                            <span>
                                                Add to {getCurrentTeam().name}'s field library
                                            </span>
                                        </p>

                                        <p className="checkbox-holder">
                                            <Checkbox checked={this.state.hidden} onChange={this.handleHideFromGuestsChange} />

                                            <span>
                                                Hide From Guests
                                            </span>
                                        </p>
                                    </div>

                                    <div className="form-row">
                                        <div className="btn-group btn-group-auto">
                                            <button className={'btn btn-success btn-has-loading' + (this.state.loading ? ' loading' : '')} disabled={this.state.loading || !this.populated} onClick={this.handleSave}>Create field</button>

                                            <button className="btn btn-link" onClick={this.props.onBack}>Back</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="custom-field-editor-pane">
                                <CustomFieldsLibrary onSelect={this.handleSelectFromLibrary} />

                                <div className="form-row">
                                    <button className="btn btn-link" onClick={this.props.onBack}>Back</button>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
}
